'use client';

import React from 'react';
import ProductCard from '@/components/ProductCard';

/**
 * Обертка для ProductCard, используемая в server components
 */
export default function ProductCardWrapper({ item, className = 'h-full' }: { item: any; className?: string }) {
  return <ProductCard item={item} className={className} />;
}

